module.exports = __webpack_public_path__ + "img/horizontal_black.1542c102.svg";